import { SuggestionsList } from './suggestions-list';
import { SponsoredListItemProduct } from './sponsored-list/sponsored-list-item-product';
import { getSponsoredElementIndex } from './utils/get-element-index';
import React from 'react';
import { SlicedSuggestions } from 'types/suggestions';
import { SponsoredProduct } from 'types/sponsored-products';
import { useTranslation } from 'react-i18next';
import { useSuggestionsButtonAction } from '../hooks/use-suggestions-button-action';
import { BrandsList } from './brands-list';

export type SponsoredProductsListProps = {
  isKzDomain: boolean;
  suggestionSelector: string;
  isDefaultList: boolean;
  index: number;
  isSrp: boolean;
  suggestions: SlicedSuggestions;
  withDivider: boolean;
  sponsoredProducts: Array<SponsoredProduct & { contentId: string }>;
  searchQuery: string;
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
};

export const SponsoredProductsList: React.FC<SponsoredProductsListProps> = ({
  isKzDomain,
  suggestionSelector,
  suggestions,
  isDefaultList,
  index,
  isSrp,
  withDivider,
  searchQuery,
  sponsoredProducts,
  buttonAction,
}) => {
  const { t } = useTranslation();

  if (isKzDomain) return null;

  return (
    <SuggestionsList
      suggestionSelector={suggestionSelector}
      withTitle={false}
      withDivider={withDivider}
      title={t('header.searchbar.sponsored')}
      aria-label={t('header.searchbar.sponsored-aria')}
      data-qa={'sponsored-product-suggestions'}
    >
      <BrandsList suggestionSelector={suggestionSelector} searchQuery={searchQuery} />
      <div>
        {sponsoredProducts.map((product, productIndex) => {
          return (
            <SponsoredListItemProduct
              key={product.productId}
              elementIndex={getSponsoredElementIndex(productIndex, suggestions, isDefaultList)}
              navigationIndex={index}
              isSrp={isSrp}
              buttonAction={buttonAction}
              productPosition={productIndex + 1}
              {...product}
              searchQuery={searchQuery}
            />
          );
        })}
      </div>
    </SuggestionsList>
  );
};
